import { ForwardedRef, forwardRef } from "react";

// Define the props interface
interface IconProps {
  name: string;
  color?: string;
  size?: number;
}

// Define the component
const Icons = forwardRef(
  (
    { name, color = "currentColor", size = 20, ...rest }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
  ) => {
    switch (name) {
      case "workspace":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 20 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g id='vuesax/linear/chart-square'>
              <g id='Group'>
                <path
                  id='Vector'
                  d='M8.42394 9.9082H6.21561C5.69061 9.9082 5.26562 10.3332 5.26562 10.8582V15.1248H8.42394V9.9082V9.9082Z'
                  stroke={color}
                  strokeWidth='1'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='Vector_2'
                  d='M10.6346 6.11719H9.36796C8.84296 6.11719 8.41797 6.5422 8.41797 7.0672V15.1172H11.5763V7.0672C11.5763 6.5422 11.1596 6.11719 10.6346 6.11719Z'
                  stroke={color}
                  strokeWidth='1'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
                <path
                  id='Vector_3'
                  d='M13.7904 11.3262H11.582V15.1179H14.7404V12.2762C14.732 11.7512 14.307 11.3262 13.7904 11.3262Z'
                  stroke={color}
                  strokeWidth='1'
                  strokeMiterlimit='10'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </g>
              <path
                id='Vector_4'
                d='M7.5013 18.9499H12.5013C16.668 18.9499 18.3346 17.2832 18.3346 13.1165V8.11654C18.3346 3.94987 16.668 2.2832 12.5013 2.2832H7.5013C3.33464 2.2832 1.66797 3.94987 1.66797 8.11654V13.1165C1.66797 17.2832 3.33464 18.9499 7.5013 18.9499Z'
                stroke={color}
                strokeWidth='1'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
          </svg>
        );
      case "dashboard":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M9.0421 9.90894H6.83378C6.30878 9.90894 5.88379 10.3339 5.88379 10.8589V15.1256H9.0421V9.90894V9.90894Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.2513 6.11719H9.98465C9.45965 6.11719 9.03467 6.5422 9.03467 7.0672V15.1172H12.193V7.0672C12.193 6.5422 11.7763 6.11719 11.2513 6.11719Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M14.4071 11.3254H12.1987V15.1171H15.3571V12.2755C15.3487 11.7505 14.9237 11.3254 14.4071 11.3254Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.11702 18.9506H13.117C17.2837 18.9506 18.9504 17.2839 18.9504 13.1173V8.11727C18.9504 3.9506 17.2837 2.28394 13.117 2.28394H8.11702C3.95036 2.28394 2.28369 3.9506 2.28369 8.11727V13.1173C2.28369 17.2839 3.95036 18.9506 8.11702 18.9506Z'
              stroke={color}
              strokeWidth='1'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );

      case "employee":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M0.679688 9.61719C0.679688 4.63795 4.67993 0.585938 9.61719 0.585938C14.5544 0.585938 18.5547 4.63795 18.5547 9.61719C18.5547 14.5964 14.5544 18.6484 9.61719 18.6484C4.67993 18.6484 0.679688 14.5964 0.679688 9.61719ZM1.05469 9.61719C1.05469 14.3583 4.89979 18.2422 9.61719 18.2422C14.3346 18.2422 18.1797 14.3583 18.1797 9.61719C18.1797 4.87607 14.3346 0.992188 9.61719 0.992188C4.89979 0.992188 1.05469 4.87607 1.05469 9.61719Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12.5234 13.3984H13.0234V12.8984V5.61719C13.0234 5.51833 13.1121 5.42969 13.2109 5.42969C13.2991 5.42969 13.4111 5.51238 13.4297 5.64335V13.2109C13.4297 13.5285 13.1535 13.8047 12.8359 13.8047H9.64844C8.86208 13.8047 8.24219 13.1848 8.24219 12.3984V9.02344C8.24219 8.92458 8.33083 8.83594 8.42969 8.83594C8.52854 8.83594 8.61719 8.92458 8.61719 9.02344V12.3984C8.61719 12.9558 9.0598 13.3984 9.61719 13.3984H12.5234Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M6.71094 5.83594H6.21094V6.33594V13.6172C6.21094 13.716 6.1223 13.8047 6.02344 13.8047C5.92458 13.8047 5.83594 13.716 5.83594 13.6172V6.02344C5.83594 5.70583 6.11208 5.42969 6.42969 5.42969H9.58594C10.3723 5.42969 10.9922 6.04958 10.9922 6.83594V10.2109C10.9922 10.3098 10.9035 10.3984 10.8047 10.3984C10.7058 10.3984 10.6172 10.3098 10.6172 10.2109V6.83594C10.6172 6.27855 10.1746 5.83594 9.61719 5.83594H6.71094Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "support":
        return (
          <svg
            ref={ref}
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            viewBox='0 0 21 20'
            fill='none'
            {...rest}
          >
            <path
              d='M13.9505 9.16406V5.83073M18.1172 1.66406H3.11719V14.9974H7.28385V18.3307L10.6172 14.9974H14.7839L18.1172 11.6641V1.66406ZM9.78385 9.16406V5.83073V9.16406Z'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "ware-housing":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 20'
            fill='none'
            {...rest}
          >
            <path
              d='M15.6172 17.5C16.9979 17.5 18.1172 16.3807 18.1172 15C18.1172 13.6193 16.9979 12.5 15.6172 12.5C14.2365 12.5 13.1172 13.6193 13.1172 15C13.1172 16.3807 14.2365 17.5 15.6172 17.5Z'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M5.61719 7.5V17.5'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.4506 5H13.9506C14.3926 5 14.8165 5.17559 15.1291 5.48816C15.4416 5.80072 15.6172 6.22464 15.6172 6.66667V12.5'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M5.61719 7.5C6.9979 7.5 8.11719 6.38071 8.11719 5C8.11719 3.61929 6.9979 2.5 5.61719 2.5C4.23648 2.5 3.11719 3.61929 3.11719 5C3.11719 6.38071 4.23648 7.5 5.61719 7.5Z'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "project-register":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14110)'>
              <path
                d='M13.9291 11.166L14.1303 11.3949L14.426 11.321C14.4787 11.3078 14.5666 11.3047 14.7422 11.3047C17.022 11.3047 18.8672 13.1992 18.8672 15.4609C18.8672 17.7182 17.0263 19.5859 14.7422 19.5859C13.8003 19.5859 12.936 19.2539 12.2322 18.7191L12.0527 18.5827L11.8316 18.6269C10.9252 18.8082 10.0206 18.8984 9.14844 18.8984C6.13671 18.8984 3.30755 17.6202 2.44857 17.2079C2.38825 17.1682 2.33774 17.0883 2.33598 16.9971C2.39758 14.7175 3.11789 12.649 4.34259 11.1902C5.19145 10.1955 6.23692 9.50252 7.35798 9.15758L8.46949 8.81557L7.4566 8.2442C6.38499 7.6397 5.64844 6.48807 5.64844 5.17969C5.64844 3.26579 7.20837 1.67969 9.14844 1.67969C11.0623 1.67969 12.6484 3.23962 12.6484 5.17969C12.6484 6.48807 11.9119 7.6397 10.8403 8.2442L9.82738 8.81557L10.9389 9.15758C12.0572 9.50167 13.075 10.1941 13.9291 11.166ZM2.77454 16.5527L2.75185 16.8931L3.06054 17.0383C4.15422 17.553 6.60627 18.4922 9.21094 18.4922C9.76998 18.4922 10.3555 18.4271 10.9078 18.3658L10.9224 18.3641L11.7297 18.2744L11.286 17.5941C10.8699 16.9561 10.6484 16.2384 10.6484 15.4297C10.6484 13.789 11.622 12.3645 13.0211 11.6929L13.6904 11.3717L13.141 10.8722C12.0288 9.86112 10.662 9.27344 9.17969 9.27344C7.45628 9.27344 5.85325 10.0679 4.6744 11.4488L4.67435 11.4488L4.669 11.4552C3.56096 12.7983 2.90537 14.5903 2.77454 16.5527ZM12.2422 5.17969C12.2422 3.46605 10.8621 2.08594 9.14844 2.08594C7.43479 2.08594 6.05469 3.46605 6.05469 5.17969C6.05469 6.89333 7.43479 8.27344 9.14844 8.27344C10.8621 8.27344 12.2422 6.89333 12.2422 5.17969ZM11.0234 15.4609C11.0234 17.5183 12.6848 19.1797 14.7422 19.1797C16.7996 19.1797 18.4609 17.5183 18.4609 15.4609C18.4609 13.4035 16.7996 11.7422 14.7422 11.7422C12.6848 11.7422 11.0234 13.4035 11.0234 15.4609Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M16.1548 14.3492L16.1548 14.3492L16.1584 14.3457C16.2066 14.2975 16.2561 14.2842 16.2898 14.2849C16.3197 14.2856 16.3519 14.2966 16.3832 14.3357L16.4005 14.3573L16.42 14.3769C16.5057 14.4626 16.506 14.5829 16.421 14.6688L14.3603 16.6984L14.3602 16.6983L14.3575 16.701C14.3475 16.7111 14.2994 16.7421 14.2111 16.7421H14.2109H14.2107H14.2106H14.2104H14.2102H14.21H14.2098H14.2097H14.2095H14.2093H14.2091H14.209H14.2088H14.2086H14.2084H14.2083H14.2081H14.2079H14.2077H14.2076H14.2074H14.2072H14.2071H14.2069H14.2067H14.2066H14.2064H14.2062H14.2061H14.2059H14.2058H14.2056H14.2054H14.2053H14.2051H14.205H14.2048H14.2046H14.2045H14.2043H14.2042H14.204H14.2039H14.2037H14.2036H14.2034H14.2033H14.2031H14.203H14.2028H14.2027H14.2025H14.2024H14.2022H14.2021H14.2019H14.2018H14.2016H14.2015H14.2013H14.2012H14.2011H14.2009H14.2008H14.2006H14.2005H14.2004H14.2002H14.2001H14.2H14.1998H14.1997H14.1995H14.1994H14.1993H14.1991H14.199H14.1989H14.1988H14.1986H14.1985H14.1984H14.1982H14.1981H14.198H14.1978H14.1977H14.1976H14.1975H14.1973H14.1972H14.1971H14.197H14.1969H14.1967H14.1966H14.1965H14.1964H14.1963H14.1961H14.196H14.1959H14.1958H14.1957H14.1955H14.1954H14.1953H14.1952H14.1951H14.195H14.1949H14.1948H14.1946H14.1945H14.1944H14.1943H14.1942H14.1941H14.194H14.1939H14.1938H14.1937H14.1936H14.1934H14.1933H14.1932H14.1931H14.193H14.1929H14.1928H14.1927H14.1926H14.1925H14.1924H14.1923H14.1922H14.1921H14.192H14.1919H14.1918H14.1917H14.1916H14.1915H14.1915H14.1914H14.1913H14.1912H14.1911H14.191H14.1909H14.1908H14.1907H14.1906H14.1905H14.1904H14.1904H14.1903H14.1902H14.1901H14.19H14.1899H14.1898H14.1897H14.1897H14.1896H14.1895H14.1894H14.1893H14.1892H14.1892H14.1891H14.189H14.1889H14.1888H14.1888H14.1887H14.1886H14.1885H14.1884H14.1884H14.1883H14.1882H14.1881H14.1881H14.188H14.1879H14.1878H14.1878H14.1877H14.1876H14.1876H14.1875H14.1874H14.1873H14.1873H14.1872H14.1871H14.1871H14.187H14.1869H14.1869H14.1868H14.1867H14.1867H14.1866H14.1865H14.1865H14.1864H14.1863H14.1863H14.1862H14.1861H14.1861H14.186H14.1859H14.1859H14.1858H14.1858H14.1857H14.1856H14.1856H14.1855H14.1855H14.1854H14.1854H14.1853H14.1852H14.1852H14.1851H14.1851H14.185H14.185H14.1849H14.1849H14.1848H14.1847H14.1847H14.1846H14.1846H14.1845H14.1845H14.1844H14.1844H14.1843H14.1843H14.1842H14.1842H14.1841H14.1841H14.184H14.184H14.1839H14.1839H14.1838H14.1838H14.1838H14.1837H14.1837H14.1836H14.1836H14.1835H14.1835H14.1834H14.1834H14.1834H14.1833H14.1833H14.1832H14.1832H14.1831H14.1831H14.1831H14.183H14.183H14.1829H14.1829H14.1829H14.1828H14.1828H14.1828H14.1827H14.1827H14.1826H14.1826H14.1826H14.1825H14.1825H14.1825H14.1824H14.1824H14.1824H14.1823H14.1823H14.1823H14.1822H14.1822H14.1822H14.1821H14.1821H14.1821H14.182H14.182H14.182H14.1819H14.1819H14.1819H14.1819H14.1818H14.1818H14.1818H14.1817H14.1817H14.1817H14.1817H14.1816H14.1816H14.1816H14.1815H14.1815H14.1815H14.1815H14.1814H14.1814H14.1814H14.1814H14.1813H14.1813H14.1813H14.1813H14.1813H14.1812H14.1812H14.1812H14.1812H14.1811H14.1811H14.1811H14.1811H14.1811H14.181H14.181H14.181H14.181H14.181H14.1809H14.1809H14.1809H14.1809H14.1809H14.1808H14.1808H14.1808H14.1808H14.1808H14.1808H14.1807H14.1807H14.1807H14.1807H14.1807H14.1807H14.1806H14.1806H14.1806H14.1806H14.1806H14.1806H14.1805H14.1805H14.1805H14.1805H14.1805H14.1805H14.1805H14.1804H14.1804H14.1804H14.1804H14.1804H14.1804H14.1804H14.1804H14.1803H14.1803H14.1803H14.1803H14.1803H14.1803H14.1803H14.1803H14.1803H14.1803H14.1802H14.1802H14.1802H14.1802H14.1802H14.1802H14.1802H14.1802H14.1802H14.1802H14.1802H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.1801H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.18H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1799H14.1798C14.1684 16.7421 14.145 16.7388 14.1133 16.7244C14.0844 16.7113 14.0582 16.6931 14.0387 16.6749L13.3291 15.9036L13.322 15.8959L13.3147 15.8885C13.2822 15.8561 13.2629 15.8089 13.2653 15.7516C13.2679 15.692 13.2933 15.6436 13.3245 15.6158L13.3355 15.606L13.3459 15.5957C13.3784 15.5632 13.4256 15.5439 13.4828 15.5463C13.5424 15.5489 13.5909 15.5743 13.6186 15.6055L13.6284 15.6165L13.6388 15.6269L13.8888 15.8769L14.2388 16.2269L14.5923 15.8805L16.1548 14.3492Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14110'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "estimate":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14116)'>
              <path
                d='M10.5683 9.97278L10.5602 9.99051L10.5535 10.0088C10.5452 10.0318 10.5184 10.0661 10.4685 10.0858C10.4216 10.1043 10.3831 10.099 10.3566 10.0845L10.3345 10.0724L10.3112 10.0626C9.652 9.78506 8.92929 9.64844 8.21094 9.64844C6.55116 9.64844 5.00948 10.4108 3.89174 11.7317L3.89018 11.7336C2.84064 12.9862 2.21798 14.7181 2.08716 16.5822L2.06285 16.9286L2.37904 17.0724C3.43183 17.5509 5.75993 18.4609 8.21094 18.4609C8.34105 18.4609 8.42969 18.5496 8.42969 18.6797C8.42969 18.737 8.40638 18.7902 8.3627 18.8326C8.3169 18.8771 8.25991 18.8984 8.21094 18.8984C5.31851 18.8984 2.60858 17.6771 1.79445 17.2718C1.73267 17.2322 1.68062 17.1504 1.6797 17.0572C1.71048 14.8417 2.39932 12.8685 3.59112 11.4732L3.59113 11.4732L3.59308 11.4709C4.37965 10.5386 5.36454 9.8751 6.42769 9.5303L7.5074 9.18012L6.52024 8.61984C5.51569 8.04969 4.83594 6.96303 4.83594 5.71094C4.83594 3.86733 6.3568 2.36719 8.21094 2.36719C10.0598 2.36719 11.5859 3.89333 11.5859 5.74219C11.5859 6.99428 10.9062 8.08094 9.90164 8.65109L8.99768 9.16415L9.96274 9.55018C10.0483 9.58439 10.1404 9.6179 10.2237 9.64816L10.2276 9.64958C10.3152 9.68145 10.3934 9.70992 10.4627 9.73768L10.4701 9.74062L10.4776 9.74333C10.4999 9.75147 10.5378 9.77923 10.5622 9.8376C10.5863 9.89503 10.5813 9.94416 10.5683 9.97278ZM11.1797 5.71094C11.1797 4.05979 9.86208 2.74219 8.21094 2.74219C6.5598 2.74219 5.24219 4.05979 5.24219 5.71094C5.24219 7.36208 6.55979 8.67969 8.21094 8.67969C9.86208 8.67969 11.1797 7.36208 11.1797 5.71094Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M11.1797 14.0859C11.1797 11.7683 13.0496 9.89844 15.3672 9.89844C17.687 9.89844 19.5877 11.7712 19.6172 14.089V18.6484C19.6172 18.7785 19.5285 18.8672 19.3984 18.8672C19.3411 18.8672 19.2879 18.8439 19.2455 18.8002C19.2011 18.7544 19.1797 18.6974 19.1797 18.6484V14.0859C19.1797 11.9973 17.4871 10.3047 15.3984 10.3047C13.3098 10.3047 11.6172 11.9973 11.6172 14.0859V18.6484C11.6172 18.7785 11.5285 18.8672 11.3984 18.8672C11.3411 18.8672 11.2879 18.8439 11.2455 18.8002C11.2011 18.7544 11.1797 18.6974 11.1797 18.6484V14.0859Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M13.6484 14.2422C13.6484 13.2996 14.4246 12.5234 15.3672 12.5234C16.3281 12.5234 17.0929 13.2892 17.1484 14.2557V14.7109C17.1484 14.841 17.0598 14.9297 16.9297 14.9297C16.8724 14.9297 16.8192 14.9064 16.7768 14.8627C16.7323 14.8169 16.7109 14.7599 16.7109 14.7109V14.2422C16.7109 13.5285 16.1121 12.9297 15.3984 12.9297C14.6848 12.9297 14.0859 13.5285 14.0859 14.2422V18.6172C14.0859 18.7473 13.9973 18.8359 13.8672 18.8359C13.8099 18.8359 13.7567 18.8126 13.7143 18.7689C13.6698 18.7232 13.6484 18.6662 13.6484 18.6172V14.2422Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M16.6797 17.1797C16.6797 17.1224 16.703 17.0692 16.7467 17.0268C16.7925 16.9823 16.8495 16.9609 16.8984 16.9609C16.9757 16.9609 17.0975 17.0325 17.1172 17.2027V18.6484C17.1172 18.7785 17.0285 18.8672 16.8984 18.8672C16.8411 18.8672 16.7879 18.8439 16.7455 18.8002C16.7011 18.7544 16.6797 18.6974 16.6797 18.6484V17.1797Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14116'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "clients":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 24 24'
            fill='none'
            stroke={color}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='lucide lucide-user-round'
            {...rest}
          >
            <circle cx='12' cy='8' r='5' />
            <path d='M20 21a8 8 0 0 0-16 0' />
          </svg>
        );
      case "projects":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14130)'>
              <path
                d='M14.1172 4.74219V5.24219H14.6172H18.1172C18.8939 5.24219 19.5587 5.88514 19.5859 6.71855V17.8984C19.5859 18.7109 18.9087 19.3672 18.1172 19.3672H3.11719C2.30472 19.3672 1.64844 18.69 1.64844 17.8984V6.71094C1.64844 5.89847 2.32566 5.24219 3.11719 5.24219H6.58594H7.08594V4.74219V3.02344C7.08594 2.39333 7.61208 1.86719 8.24219 1.86719H12.9609C13.591 1.86719 14.1172 2.39333 14.1172 3.02344V4.74219ZM13.2109 5.27344H13.7109V4.77344V3.05469C13.7109 2.58223 13.3202 2.30469 12.9609 2.30469H8.24219C7.84104 2.30469 7.52344 2.6223 7.52344 3.02344V4.77344V5.27344H8.02344H13.2109ZM18.8111 9.63087L19.1797 9.53048V9.14844V6.71094C19.1797 6.12229 18.7058 5.64844 18.1172 5.64844H3.11719C2.5095 5.64844 2.08594 6.14173 2.08594 6.67969V9.11719V9.49723L2.45212 9.59895L9.76462 11.6302L10.3984 11.8063V11.1484V10.4922C10.3984 10.3621 10.4871 10.2734 10.6172 10.2734C10.6745 10.2734 10.7277 10.2967 10.7701 10.3404C10.8146 10.3862 10.8359 10.4432 10.8359 10.4922V11.1484V11.8028L11.4673 11.6309L18.8111 9.63087ZM2.68607 10.1035L2.05469 9.93156V10.5859V17.8672C2.05469 18.4558 2.52855 18.9297 3.11719 18.9297H18.1172C18.7324 18.9297 19.1229 18.4374 19.1766 17.9537L19.1797 17.9261V17.8984V10.5859V9.93156L18.5483 10.1035L11.2046 12.1035L10.8359 12.2039V12.5859V13.2734C10.8359 13.4035 10.7473 13.4922 10.6172 13.4922C10.5599 13.4922 10.5067 13.4689 10.4643 13.4252C10.4198 13.3794 10.3984 13.3224 10.3984 13.2734V12.5859V12.2039L10.0298 12.1035L2.68607 10.1035Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14130'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "reports":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M9.0421 9.90894H6.83378C6.30878 9.90894 5.88379 10.3339 5.88379 10.8589V15.1256H9.0421V9.90894V9.90894Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.2513 6.11719H9.98465C9.45965 6.11719 9.03467 6.5422 9.03467 7.0672V15.1172H12.193V7.0672C12.193 6.5422 11.7763 6.11719 11.2513 6.11719Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M14.4071 11.3254H12.1987V15.1171H15.3571V12.2755C15.3487 11.7505 14.9237 11.3254 14.4071 11.3254Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.11702 18.9506H13.117C17.2837 18.9506 18.9504 17.2839 18.9504 13.1173V8.11727C18.9504 3.9506 17.2837 2.28394 13.117 2.28394H8.11702C3.95036 2.28394 2.28369 3.9506 2.28369 8.11727V13.1173C2.28369 17.2839 3.95036 18.9506 8.11702 18.9506Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );

      case "tasks":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14146)'>
              <path
                d='M2.27344 9.55469H1.77344V10.0547V14.0859C1.77344 14.9202 2.52802 15.5234 3.36719 15.5234H10.5859C10.7307 15.5234 10.8047 15.6265 10.8047 15.7109C10.8047 15.7417 10.7903 15.7869 10.7433 15.8312C10.6953 15.8763 10.6357 15.8984 10.5859 15.8984H3.36719C2.23856 15.8984 1.36719 15.0309 1.36719 14.0547V4.99219C1.36719 4.01594 2.23856 3.14844 3.36719 3.14844H17.8672C18.9958 3.14844 19.8672 4.01594 19.8672 4.99219V12.3984C19.8672 12.4973 19.7785 12.5859 19.6797 12.5859C19.5808 12.5859 19.4922 12.4973 19.4922 12.3984V10.0547V9.55469H18.9922H2.27344ZM18.9609 6.42969H19.4609V5.92969V4.99219C19.4609 4.1579 18.7064 3.55469 17.8672 3.55469H3.36719C2.5476 3.55469 1.74219 4.14101 1.74219 4.99219V5.92969V6.42969H2.24219H18.9609ZM1.74219 8.64844V9.14844H2.24219H18.9609H19.4609V8.64844V7.36719V6.86719H18.9609H2.24219H1.74219V7.36719V8.64844Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M16.5411 15.3553L16.5492 15.3376L16.5558 15.3193C16.5805 15.2514 16.6803 15.1852 16.7999 15.235C17.3625 15.4694 17.6949 15.9942 17.6499 16.5788L17.6484 16.598V16.6172C17.6484 17.4348 16.966 18.1172 16.1484 18.1172C15.3308 18.1172 14.6484 17.4348 14.6484 16.6172V14.1484V13.6484H14.1484H13.6172C13.5183 13.6484 13.4297 13.5598 13.4297 13.4609C13.4297 13.3621 13.5183 13.2734 13.6172 13.2734H14.1484H14.6484V12.7734V11.9922V11.4922H14.1484H14.0234H13.5234V11.9922C13.5234 12.091 13.4348 12.1797 13.3359 12.1797C13.3052 12.1797 13.2599 12.1653 13.2157 12.1183C13.1706 12.0703 13.1484 12.0107 13.1484 11.9609C13.1484 11.4558 13.5496 11.0547 14.0547 11.0547H14.2109C14.716 11.0547 15.1172 11.4558 15.1172 11.9609V12.7422V13.2422H15.6172H17.3984C17.4973 13.2422 17.5859 13.3308 17.5859 13.4297C17.5859 13.5285 17.4973 13.6172 17.3984 13.6172H15.6484H15.1484V14.1172V16.5859C15.1484 17.2228 15.6708 17.6797 16.2422 17.6797C16.8308 17.6797 17.3359 17.1746 17.3359 16.5859C17.3359 16.1412 17.0354 15.7569 16.6579 15.5951L16.645 15.5896L16.6318 15.5848C16.6094 15.5767 16.5716 15.5489 16.5472 15.4905C16.5231 15.4331 16.5281 15.384 16.5411 15.3553Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14146'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "items":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14152)'>
              <path
                d='M14.0593 3.90343L14.1182 4.33587H14.5547H18.1172C18.914 4.33587 19.5859 4.99731 19.5859 5.77337V11.8671C19.5859 12.6796 18.9087 13.3359 18.1172 13.3359H15.9297H15.3693L15.4329 13.8926L16.0579 19.3614L16.0594 19.3742L16.0615 19.3868C16.0676 19.4237 16.0592 19.4644 16.0272 19.5055C15.9991 19.5416 15.9571 19.5712 15.908 19.5859H15.908H15.9078H15.9077H15.9075H15.9073H15.9071H15.9069H15.9067H15.9066H15.9064H15.9062H15.906H15.9058H15.9056H15.9055H15.9053H15.9051H15.9049H15.9047H15.9045H15.9044H15.9042H15.904H15.9038H15.9036H15.9034H15.9033H15.9031H15.9029H15.9027H15.9025H15.9023H15.9022H15.902H15.9018H15.9016H15.9014H15.9012H15.9011H15.9009H15.9007H15.9005H15.9003H15.9001H15.9H15.8998H15.8996H15.8994H15.8992H15.899H15.8989H15.8987H15.8985H15.8983H15.8981H15.8979H15.8978H15.8976H15.8974H15.8972H15.897H15.8968H15.8967H15.8965H15.8963H15.8961H15.8959H15.8958H15.8956H15.8954H15.8952H15.895H15.8948H15.8947H15.8945H15.8943H15.8941H15.8939H15.8937H15.8936H15.8934H15.8932H15.893H15.8928H15.8926H15.8925H15.8923H15.8921H15.8919H15.8917H15.8915H15.8914H15.8912H15.891H15.8908H15.8906H15.8904H15.8903H15.8901H15.8899H15.8897H15.8895H15.8893H15.8892H15.889H15.8888H15.8886H15.8884H15.8882H15.8881H15.8879H15.8877H15.8875H15.8873H15.8871H15.887H15.8868H15.8866H15.8864H15.8862H15.886H15.8859H15.8857H15.8855H15.8853H15.8851H15.8849H15.8848H15.8846H15.8844H15.8842H15.884H15.8838H15.8837H15.8835H15.8833H15.8831H15.8829H15.8827H15.8826H15.8824H15.8822H15.882H15.8818H15.8817H15.8815H15.8813H15.8811H15.8809H15.8807H15.8806H15.8804H15.8802H15.88H15.8798H15.8796H15.8795H15.8793H15.8791H15.8789H15.8787H15.8785H15.8784H15.8782H15.878H15.8778H15.8776H15.8774H15.8773H15.8771H15.8769H15.8767H15.8765H15.8763H15.8762H15.876H15.8758H15.8756H15.8754H15.8752H15.8751H15.8749H15.8747H15.8745H15.8743H15.8741H15.874H15.8738H15.8736H15.8734H15.8732H15.873H15.8729H15.8727H15.8725H15.8723H15.8721H15.8719H15.8718H15.8716H15.8714H15.8712H15.871H15.8708H15.8707H15.8705H15.8703H15.8701H15.8699H15.8697H15.8696H15.8694H15.8692H15.869H15.8688H15.8687H15.8685H15.8683H15.8681H15.8679H15.8677H15.8676H15.8674H15.8672C15.7852 19.5859 15.6985 19.5297 15.6734 19.4115L14.9253 13.801L14.8674 13.3671H14.4297H6.67969H6.24193L6.18407 13.801L5.43407 19.426L5.43269 19.4364L5.43174 19.4469C5.42918 19.475 5.41533 19.5065 5.38069 19.5358C5.34434 19.5664 5.29403 19.5859 5.24219 19.5859H5.242H5.24182H5.24164H5.24145H5.24127H5.24109H5.24091H5.24072H5.24054H5.24036H5.24017H5.23999H5.23981H5.23962H5.23944H5.23926H5.23907H5.23889H5.23871H5.23852H5.23834H5.23816H5.23798H5.23779H5.23761H5.23743H5.23724H5.23706H5.23688H5.23669H5.23651H5.23633H5.23614H5.23596H5.23578H5.2356H5.23541H5.23523H5.23505H5.23486H5.23468H5.2345H5.23431H5.23413H5.23395H5.23376H5.23358H5.2334H5.23321H5.23303H5.23285H5.23267H5.23248H5.2323H5.23212H5.23193H5.23175H5.23157H5.23138H5.2312H5.23102H5.23083H5.23065H5.23047H5.23029H5.2301H5.22992H5.22974H5.22955H5.22937H5.22919H5.229H5.22882H5.22864H5.22845H5.22827H5.22809H5.2279H5.22772H5.22754H5.22736H5.22717H5.22699H5.22681H5.22662H5.22644H5.22626H5.22607H5.22589H5.22571H5.22552H5.22534H5.22516H5.22498H5.22479H5.22461H5.22443H5.22424H5.22406H5.22388H5.22369H5.22351H5.22333H5.22314H5.22296H5.22278H5.22259H5.22241H5.22223H5.22205H5.22186H5.22168H5.2215H5.22131H5.22113H5.22095H5.22076H5.22058H5.2204H5.22021H5.22003H5.21985H5.21967H5.21948H5.2193H5.21912H5.21893H5.21875H5.21857H5.21838H5.2182H5.21802H5.21783H5.21765H5.21747H5.21728H5.2171H5.21692H5.21674H5.21655H5.21637H5.21619H5.216H5.21582H5.21564H5.21545H5.21527H5.21509H5.2149H5.21472H5.21454H5.21435H5.21417H5.21399H5.21381H5.21362H5.21344H5.21326H5.21307H5.21289H5.21271H5.21252H5.21234H5.21216H5.21197H5.21179H5.21161H5.21143H5.21124H5.21106H5.21088H5.21069H5.21051H5.21033H5.21014H5.20996H5.20978H5.20959H5.20941H5.20923H5.20904H5.20886H5.20868H5.2085H5.20831H5.20813H5.20795H5.20776H5.20758H5.2074H5.20721H5.20703H5.20685H5.20666H5.20648H5.2063H5.20612H5.20593H5.20575H5.20557H5.20538H5.2052H5.20502H5.20483H5.20465H5.20447H5.20428H5.2041H5.20392H5.20373H5.20355H5.20337H5.20319H5.203H5.20282H5.20264H5.20245H5.20227H5.20209H5.2019H5.20172H5.20154H5.20135H5.20117H5.20099H5.20081H5.20062H5.20044H5.20026H5.20007H5.19989H5.19971H5.19952H5.19934H5.19916H5.19897H5.19879H5.19861H5.19842H5.19824H5.19806H5.19788H5.19769H5.19751H5.19733H5.19714H5.19696H5.19678H5.19659H5.19641H5.19623H5.19604H5.19586H5.19568H5.1955H5.19531H5.19513H5.19495H5.19476H5.19458H5.1944H5.19421H5.19403H5.19385H5.19366H5.19348H5.1933H5.19311H5.19293H5.19275H5.19257H5.19238H5.1922H5.19202H5.19183H5.19165H5.19147H5.19128H5.1911H5.19092H5.19073H5.19055H5.19037H5.19019H5.19H5.18982H5.18964H5.18945H5.18927H5.18909H5.1889H5.18872H5.18854H5.18835H5.18817H5.18799H5.1878H5.18762H5.18744H5.18726H5.18707H5.18689H5.18671H5.18652H5.18634H5.18616H5.18597H5.18579H5.18561H5.18542H5.18524H5.18506H5.18488H5.18469H5.18451H5.18433H5.18414H5.18396H5.18378H5.18359H5.18341H5.18323H5.18304H5.18286H5.18268H5.18249H5.18231H5.18213H5.18195H5.18176H5.18158H5.1814H5.18121H5.18103H5.18085H5.18066H5.18048H5.1803H5.18011H5.17993H5.17975H5.17956H5.17938H5.1792H5.17902H5.17883H5.17865H5.17847H5.17828H5.1781H5.17809C5.15036 19.5802 5.11603 19.5618 5.0862 19.5224C5.05173 19.4769 5.04131 19.4263 5.04788 19.3868L5.04808 19.3869L5.05 19.3729L5.8 13.9354L5.87839 13.3671H5.30469H3.11719C2.30472 13.3671 1.64844 12.6899 1.64844 11.8984V5.80462C1.64844 4.99215 2.32566 4.33587 3.11719 4.33587H6.67969H7.11613L7.1751 3.90343L7.45635 1.84093L7.45812 1.82795L7.45921 1.81489C7.46165 1.78558 7.47912 1.74538 7.52438 1.71113C7.56992 1.67667 7.62055 1.66624 7.65999 1.67282L7.68022 1.67619L7.70066 1.67789C7.72997 1.68033 7.77017 1.6978 7.80442 1.74306C7.83889 1.78861 7.84931 1.83924 7.84274 1.87867L7.8414 1.88671L7.84032 1.89479L7.59032 3.76979L7.51484 4.33587H8.08594H13.1484H13.7195L13.644 3.76979L13.394 1.89479L13.393 1.88671L13.3916 1.87867C13.3855 1.84183 13.394 1.80112 13.4259 1.76003C13.4595 1.71683 13.5128 1.68308 13.5744 1.67282C13.6112 1.66668 13.6519 1.67514 13.693 1.70711C13.735 1.73974 13.768 1.79096 13.7793 1.85028L14.0593 3.90343ZM18.1172 12.9609C18.7058 12.9609 19.1797 12.487 19.1797 11.8984V5.77337C19.1797 5.18473 18.7058 4.71087 18.1172 4.71087H13.9297H7.27344H3.11719C2.52854 4.71087 2.05469 5.18473 2.05469 5.77337V11.8984C2.05469 12.487 2.52855 12.9609 3.11719 12.9609H18.1172Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14152'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "tools":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14156)'>
              <mask id='path-1-inside-1_239_14156' fill='white'>
                <path d='M19.3672 14.3358L17.4297 12.3983C16.6484 11.6171 15.3672 11.6171 14.5859 12.3983L14.0547 12.9296L12.3359 11.2108L13.9609 9.58585L17.1484 8.7421C17.8359 8.5546 18.3984 7.9921 18.5859 7.3046L19.4922 3.96085C19.5859 3.58585 19.3672 3.21085 18.9922 3.08585C18.6172 2.9921 18.2422 3.21085 18.1172 3.58585L17.2109 6.9296C17.1484 7.14835 16.9922 7.3046 16.7734 7.3671L13.4297 8.27335C13.3047 8.3046 13.2109 8.3671 13.1172 8.46085L11.3672 10.2108L10.3047 9.14835L12.0547 7.39835C12.1484 7.3046 12.2109 7.21085 12.2422 7.08585L13.1172 3.7421C13.1797 3.52335 13.3359 3.3671 13.5547 3.3046L16.8984 2.39835C17.2734 2.3046 17.4922 1.89835 17.3984 1.52335C17.3047 1.14835 16.9297 0.929598 16.5547 1.0546L13.2109 1.9296C12.5234 2.1171 11.9609 2.6796 11.7734 3.3671L10.9297 6.52335L9.30469 8.14835L7.67969 6.52335C8.30469 5.8046 8.36719 4.7421 7.80469 3.96085L6.46095 2.1796C6.1172 1.71085 5.58594 1.4296 4.99219 1.39835C4.39844 1.3671 3.83594 1.5546 3.42969 1.9921L2.14845 3.27335C1.7422 3.6796 1.52345 4.2421 1.5547 4.83585C1.58595 5.4296 1.8672 5.96085 2.33595 6.3046L4.11719 7.64835C4.46094 7.9296 4.89845 8.0546 5.33595 8.0546C5.83595 8.0546 6.30469 7.8671 6.67969 7.52335L8.30469 9.14835L6.21094 11.2421L3.0547 12.0858C2.3672 12.2733 1.8047 12.8358 1.6172 13.5233L0.929695 16.1171C0.742195 16.8046 0.929695 17.5546 1.46095 18.0858L2.4297 19.0546C2.8047 19.4296 3.33594 19.6483 3.86719 19.6483C4.05469 19.6483 4.21095 19.6171 4.39845 19.5858L6.99219 18.8983C7.67969 18.7108 8.24219 18.1483 8.42969 17.4608L9.27345 14.3046L11.3672 12.2108L13.0859 13.9296L12.5547 14.4608C11.7734 15.2421 11.7734 16.5233 12.5547 17.3046L14.4922 19.2421C15.1484 19.8983 15.9922 20.2421 16.9297 20.2421C17.8672 20.2421 18.7109 19.8983 19.3672 19.2421C20.0234 18.5858 20.3672 17.7421 20.3672 16.8046C20.3672 15.8671 20.0234 14.9921 19.3672 14.3358ZM4.96094 6.4921L3.17969 5.14835C2.99219 4.9921 2.96095 4.8046 2.9297 4.71085C2.9297 4.6171 2.9297 4.39835 3.1172 4.2421L4.39845 2.96085C4.5547 2.8046 4.71094 2.77335 4.83594 2.77335H4.8672C4.96095 2.77335 5.14844 2.83585 5.30469 3.02335L6.64844 4.8046C6.83594 5.0546 6.80469 5.3671 6.58594 5.58585L5.74219 6.4296C5.55469 6.64835 5.21094 6.6796 4.96094 6.4921ZM8.14844 13.4296C8.05469 13.5233 7.99219 13.6171 7.96094 13.7421L7.05469 17.0858C6.99219 17.3046 6.83595 17.4608 6.6172 17.5233L4.02344 18.2108C3.80469 18.2733 3.58594 18.2108 3.42969 18.0546L2.46095 17.0858C2.3047 16.9296 2.2422 16.7108 2.3047 16.4921L2.9922 13.8983C3.0547 13.6796 3.21095 13.5233 3.42969 13.4608L6.77345 12.5546C6.89845 12.5233 6.9922 12.4608 7.08595 12.3671L9.33594 10.1171L10.3984 11.1796L8.14844 13.4296ZM18.3672 18.2108C17.9922 18.5858 17.4609 18.8046 16.9297 18.8046C16.3984 18.8046 15.8672 18.5858 15.4922 18.2108L13.5547 16.2733C13.3359 16.0546 13.3359 15.6483 13.5547 15.4296L14.0859 14.8983L14.5234 15.3358C14.6484 15.4608 14.8359 15.5546 15.0234 15.5546C15.2109 15.5546 15.3984 15.4921 15.5234 15.3358C15.8047 15.0546 15.8047 14.6171 15.5234 14.3358L15.0859 13.8983L15.6172 13.3671C15.7422 13.2421 15.8672 13.1796 16.0547 13.1796C16.2109 13.1796 16.3672 13.2421 16.4922 13.3671L18.4297 15.3046C18.8047 15.6796 19.0234 16.2108 19.0234 16.7421C19.0234 17.2733 18.7734 17.8358 18.3672 18.2108Z' />
              </mask>
              <path
                d='M19.3672 14.3358L17.4297 12.3983C16.6484 11.6171 15.3672 11.6171 14.5859 12.3983L14.0547 12.9296L12.3359 11.2108L13.9609 9.58585L17.1484 8.7421C17.8359 8.5546 18.3984 7.9921 18.5859 7.3046L19.4922 3.96085C19.5859 3.58585 19.3672 3.21085 18.9922 3.08585C18.6172 2.9921 18.2422 3.21085 18.1172 3.58585L17.2109 6.9296C17.1484 7.14835 16.9922 7.3046 16.7734 7.3671L13.4297 8.27335C13.3047 8.3046 13.2109 8.3671 13.1172 8.46085L11.3672 10.2108L10.3047 9.14835L12.0547 7.39835C12.1484 7.3046 12.2109 7.21085 12.2422 7.08585L13.1172 3.7421C13.1797 3.52335 13.3359 3.3671 13.5547 3.3046L16.8984 2.39835C17.2734 2.3046 17.4922 1.89835 17.3984 1.52335C17.3047 1.14835 16.9297 0.929598 16.5547 1.0546L13.2109 1.9296C12.5234 2.1171 11.9609 2.6796 11.7734 3.3671L10.9297 6.52335L9.30469 8.14835L7.67969 6.52335C8.30469 5.8046 8.36719 4.7421 7.80469 3.96085L6.46095 2.1796C6.1172 1.71085 5.58594 1.4296 4.99219 1.39835C4.39844 1.3671 3.83594 1.5546 3.42969 1.9921L2.14845 3.27335C1.7422 3.6796 1.52345 4.2421 1.5547 4.83585C1.58595 5.4296 1.8672 5.96085 2.33595 6.3046L4.11719 7.64835C4.46094 7.9296 4.89845 8.0546 5.33595 8.0546C5.83595 8.0546 6.30469 7.8671 6.67969 7.52335L8.30469 9.14835L6.21094 11.2421L3.0547 12.0858C2.3672 12.2733 1.8047 12.8358 1.6172 13.5233L0.929695 16.1171C0.742195 16.8046 0.929695 17.5546 1.46095 18.0858L2.4297 19.0546C2.8047 19.4296 3.33594 19.6483 3.86719 19.6483C4.05469 19.6483 4.21095 19.6171 4.39845 19.5858L6.99219 18.8983C7.67969 18.7108 8.24219 18.1483 8.42969 17.4608L9.27345 14.3046L11.3672 12.2108L13.0859 13.9296L12.5547 14.4608C11.7734 15.2421 11.7734 16.5233 12.5547 17.3046L14.4922 19.2421C15.1484 19.8983 15.9922 20.2421 16.9297 20.2421C17.8672 20.2421 18.7109 19.8983 19.3672 19.2421C20.0234 18.5858 20.3672 17.7421 20.3672 16.8046C20.3672 15.8671 20.0234 14.9921 19.3672 14.3358ZM4.96094 6.4921L3.17969 5.14835C2.99219 4.9921 2.96095 4.8046 2.9297 4.71085C2.9297 4.6171 2.9297 4.39835 3.1172 4.2421L4.39845 2.96085C4.5547 2.8046 4.71094 2.77335 4.83594 2.77335H4.8672C4.96095 2.77335 5.14844 2.83585 5.30469 3.02335L6.64844 4.8046C6.83594 5.0546 6.80469 5.3671 6.58594 5.58585L5.74219 6.4296C5.55469 6.64835 5.21094 6.6796 4.96094 6.4921ZM8.14844 13.4296C8.05469 13.5233 7.99219 13.6171 7.96094 13.7421L7.05469 17.0858C6.99219 17.3046 6.83595 17.4608 6.6172 17.5233L4.02344 18.2108C3.80469 18.2733 3.58594 18.2108 3.42969 18.0546L2.46095 17.0858C2.3047 16.9296 2.2422 16.7108 2.3047 16.4921L2.9922 13.8983C3.0547 13.6796 3.21095 13.5233 3.42969 13.4608L6.77345 12.5546C6.89845 12.5233 6.9922 12.4608 7.08595 12.3671L9.33594 10.1171L10.3984 11.1796L8.14844 13.4296ZM18.3672 18.2108C17.9922 18.5858 17.4609 18.8046 16.9297 18.8046C16.3984 18.8046 15.8672 18.5858 15.4922 18.2108L13.5547 16.2733C13.3359 16.0546 13.3359 15.6483 13.5547 15.4296L14.0859 14.8983L14.5234 15.3358C14.6484 15.4608 14.8359 15.5546 15.0234 15.5546C15.2109 15.5546 15.3984 15.4921 15.5234 15.3358C15.8047 15.0546 15.8047 14.6171 15.5234 14.3358L15.0859 13.8983L15.6172 13.3671C15.7422 13.2421 15.8672 13.1796 16.0547 13.1796C16.2109 13.1796 16.3672 13.2421 16.4922 13.3671L18.4297 15.3046C18.8047 15.6796 19.0234 16.2108 19.0234 16.7421C19.0234 17.2733 18.7734 17.8358 18.3672 18.2108Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14156'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "waste-manage":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M9.0421 9.90894H6.83378C6.30878 9.90894 5.88379 10.3339 5.88379 10.8589V15.1256H9.0421V9.90894V9.90894Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M11.2513 6.11719H9.98465C9.45965 6.11719 9.03467 6.5422 9.03467 7.0672V15.1172H12.193V7.0672C12.193 6.5422 11.7763 6.11719 11.2513 6.11719Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M14.4071 11.3254H12.1987V15.1171H15.3571V12.2755C15.3487 11.7505 14.9237 11.3254 14.4071 11.3254Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.11702 18.9506H13.117C17.2837 18.9506 18.9504 17.2839 18.9504 13.1173V8.11727C18.9504 3.9506 17.2837 2.28394 13.117 2.28394H8.11702C3.95036 2.28394 2.28369 3.9506 2.28369 8.11727V13.1173C2.28369 17.2839 3.95036 18.9506 8.11702 18.9506Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "messages":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='lucide lucide-messages-square-icon lucide-messages-square'
          >
            <path d='M14 9a2 2 0 0 1-2 2H6l-4 4V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2z' />
            <path d='M18 9h2a2 2 0 0 1 2 2v11l-4-4h-6a2 2 0 0 1-2-2v-1' />
          </svg>
        );
      case "ohs":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14176)'>
              <path
                d='M13.1074 1.90824L13.1074 1.90825L13.11 1.91081L17.4199 6.15824C17.4203 6.15861 17.4206 6.15898 17.421 6.15935C17.5663 6.30528 17.6484 6.51636 17.6484 6.74219V18.1484C17.6484 18.9609 16.9712 19.6172 16.1797 19.6172H5.02344C4.21097 19.6172 3.55469 18.94 3.55469 18.1484V3.14844C3.55469 2.33597 4.23191 1.67969 5.02344 1.67969H12.5234C12.7498 1.67969 12.9614 1.76227 13.1074 1.90824ZM13.8434 3.19877L12.9922 2.35895V3.55469V5.86719V6.36719H13.4922H15.8359H17.0546L16.1871 5.51127L13.8434 3.19877ZM12.5859 2.55469V2.05469H12.0859H5.02344C4.4348 2.05469 3.96094 2.52855 3.96094 3.11719V18.1172C3.96094 18.7058 4.4348 19.1797 5.02344 19.1797H16.2109C16.7926 19.1797 17.2187 18.6892 17.271 18.1669L17.2734 18.1421V18.1172V7.27344V6.77344H16.7734H12.8047C12.7474 6.77344 12.6942 6.75013 12.6518 6.70645C12.6073 6.66065 12.5859 6.60366 12.5859 6.55469V2.55469Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M7.36719 10.2109H12.7734C12.9035 10.2109 12.9922 10.2996 12.9922 10.4297C12.9922 10.487 12.9689 10.5402 12.9252 10.5826C12.8794 10.6271 12.8224 10.6484 12.7734 10.6484H7.36719C7.23708 10.6484 7.14844 10.5598 7.14844 10.4297C7.14844 10.3724 7.17174 10.3192 7.21543 10.2768C7.26122 10.2323 7.31822 10.2109 7.36719 10.2109Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M7.36719 13.6484H12.7734C12.9035 13.6484 12.9922 13.7371 12.9922 13.8672C12.9922 13.9245 12.9689 13.9777 12.9252 14.0201C12.8794 14.0646 12.8224 14.0859 12.7734 14.0859H7.36719C7.23708 14.0859 7.14844 13.9973 7.14844 13.8672C7.14844 13.8099 7.17174 13.7567 7.21543 13.7143C7.26122 13.6698 7.31822 13.6484 7.36719 13.6484Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14176'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "announcement":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_239_14192)'>
              <path
                d='M10.7373 5.28315L11.253 5.54097L11.4353 4.99405C11.9951 3.3147 13.56 2.11719 15.3984 2.11719C17.7138 2.11719 19.5234 3.95362 19.5234 6.24219C19.5234 8.52854 17.6535 10.3984 15.3672 10.3984C15.0165 10.3984 14.69 10.3688 14.405 10.2911L13.7734 10.1188V10.7734V15.3984C13.7734 15.6458 13.8296 15.8597 13.9697 16.0932L13.9747 16.1015L13.9799 16.1096L14.505 16.9126C14.5934 17.0652 14.592 17.2393 14.5009 17.3912L14.4967 17.3983L14.4926 17.4056C14.4327 17.5134 14.3281 17.5859 14.1484 17.5859H8.80468H8.30468V18.0859V18.9297C8.30468 19.0285 8.21604 19.1172 8.11718 19.1172C8.01833 19.1172 7.92968 19.0285 7.92968 18.9297V18.0859V17.5859H7.42968H2.11718C1.94508 17.5859 1.81798 17.517 1.72071 17.3711L1.69324 17.3299L1.67256 17.3092C1.6332 17.2224 1.63428 17.0867 1.72071 16.957L1.72807 16.946L1.73483 16.9346L2.23483 16.0908L2.24392 16.0755L2.2519 16.0595C2.29942 15.9645 2.3854 15.7838 2.42582 15.4605L2.42968 15.4296V15.3984V10.0234C2.42968 7.33766 4.54837 5.04022 7.39543 4.71094H7.39549H7.39558H7.39567H7.39577H7.39586H7.39595H7.39604H7.39614H7.39623H7.39632H7.39641H7.39651H7.3966H7.39669H7.39678H7.39687H7.39697H7.39706H7.39715H7.39724H7.39733H7.39743H7.39752H7.39761H7.3977H7.39779H7.39788H7.39797H7.39807H7.39816H7.39825H7.39834H7.39843H7.39852H7.39862H7.39871H7.3988H7.39889H7.39898H7.39907H7.39917H7.39926H7.39935H7.39944H7.39953H7.39962H7.39972H7.39981H7.3999H7.39999H7.40008H7.40018H7.40027H7.40036H7.40045H7.40054H7.40064H7.40073H7.40082H7.40091H7.40101H7.4011H7.40119H7.40128H7.40138H7.40147H7.40156H7.40166H7.40175H7.40184H7.40194H7.40203H7.40212H7.40222H7.40231H7.40241H7.4025H7.4026H7.40269H7.40278H7.40288H7.40297H7.40307H7.40316H7.40326H7.40335H7.40345H7.40355H7.40364H7.40374H7.40383H7.40393H7.40403H7.40412H7.40422H7.40432H7.40441H7.40451H7.40461H7.40471H7.4048H7.4049H7.405H7.4051H7.4052H7.4053H7.4054H7.4055H7.4056H7.40569H7.4058H7.4059H7.406H7.4061H7.4062H7.4063H7.4064H7.4065H7.4066H7.4067H7.40681H7.40691H7.40701H7.40711H7.40722H7.40732H7.40743H7.40753H7.40763H7.40774H7.40784H7.40795H7.40805H7.40816H7.40827H7.40837H7.40848H7.40859H7.40869H7.4088H7.40891H7.40902H7.40912H7.40923H7.40934H7.40945H7.40956H7.40967H7.40978H7.40989H7.41H7.41011H7.41022H7.41034H7.41045H7.41056H7.41067H7.41079H7.4109H7.41101H7.41113H7.41124H7.41136H7.41147H7.41159H7.41171H7.41182H7.41194H7.41206H7.41217H7.41229H7.41241H7.41253H7.41265H7.41277H7.41289H7.41301H7.41313H7.41325H7.41337H7.41349H7.41361H7.41374H7.41386H7.41398H7.41411H7.41423H7.41436H7.41448H7.41461H7.41473H7.41486H7.41499H7.41512H7.41524H7.41537H7.4155H7.41563H7.41576H7.41589H7.41602H7.41615H7.41628H7.41642H7.41655H7.41668H7.41682H7.41695H7.41708H7.41722H7.41736H7.41749H7.41763H7.41777H7.4179H7.41804H7.41818H7.41832H7.41846H7.4186H7.41874H7.41888H7.41902H7.41916H7.41931H7.41945H7.41959H7.41974H7.41988H7.42003H7.42017H7.42032H7.42047H7.42062H7.42076H7.42091H7.42106H7.42121H7.42136H7.42151H7.42167H7.42182H7.42197H7.42212H7.42228H7.42243H7.42259H7.42274H7.4229H7.42306H7.42322H7.42337H7.42353H7.42369H7.42385H7.42401H7.42417H7.42434H7.4245H7.42466H7.42483H7.42499H7.42516H7.42532H7.42549H7.42565H7.42582H7.42599H7.42616H7.42633H7.4265H7.42667H7.42684H7.42701H7.42719H7.42736H7.42754H7.42771H7.42789H7.42806H7.42824H7.42842H7.4286H7.42878H7.42896H7.42914H7.42932H7.4295H7.42968H7.92968V4.21094V3.08594C7.92968 2.98708 8.01832 2.89844 8.11718 2.89844C8.21604 2.89844 8.30468 2.98708 8.30468 3.08594V4.21094V4.65233L8.74267 4.70708C9.44956 4.79544 10.1112 4.97006 10.7373 5.28315ZM13.6582 16.2949L13.6433 16.28C13.4801 15.9855 13.4077 15.7247 13.4284 15.4341L13.4297 15.4163V15.3984V10.1797V9.9047L13.1975 9.75743C12.0506 9.03015 11.2734 7.74669 11.2734 6.30469V6.01683L11.0245 5.87229C9.96499 5.2571 8.73363 4.98359 7.47041 5.12001C4.86577 5.39451 2.83593 7.49387 2.83593 10.0234V15.4843C2.77865 15.8387 2.70078 16.065 2.59943 16.2272L2.59936 16.2271L2.59469 16.2349L2.50094 16.3912L2.04659 17.1484H2.92968H13.3047H14.5118L13.6582 16.2949ZM11.6484 6.27344C11.6484 8.33083 13.341 10.0234 15.3984 10.0234C17.4902 10.0234 19.1484 8.32769 19.1484 6.27344C19.1484 4.21605 17.4558 2.52344 15.3984 2.52344C13.341 2.52344 11.6484 4.21605 11.6484 6.27344Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M15.6172 5.55469V6.05469H16.1172H16.5547C16.6535 6.05469 16.7422 6.14333 16.7422 6.24219C16.7422 6.34105 16.6535 6.42969 16.5547 6.42969H16.1172H15.6172V6.92969V7.36719C15.6172 7.46605 15.5285 7.55469 15.4297 7.55469C15.3308 7.55469 15.2422 7.46605 15.2422 7.36719V6.92969V6.42969H14.7422H14.3047C14.2058 6.42969 14.1172 6.34105 14.1172 6.24219C14.1172 6.14333 14.2058 6.05469 14.3047 6.05469H14.7422H15.2422V5.55469V5.11719C15.2422 5.01833 15.3308 4.92969 15.4297 4.92969C15.5285 4.92969 15.6172 5.01833 15.6172 5.11719V5.55469Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_239_14192'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );

      case "admin-staff":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 25 25'
            // stroke={color}
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M12.9291 10.4316L13.1303 10.6606L13.426 10.5866C13.4787 10.5734 13.5666 10.5703 13.7422 10.5703C16.022 10.5703 17.8672 12.4649 17.8672 14.7266C17.8672 16.9839 16.0263 18.8516 13.7422 18.8516C12.8003 18.8516 11.936 18.5196 11.2322 17.9847L11.0527 17.8483L10.8316 17.8925C9.92522 18.0738 9.02056 18.1641 8.14844 18.1641C5.13671 18.1641 2.30755 16.8858 1.44857 16.4735C1.38825 16.4338 1.33774 16.3539 1.33598 16.2627C1.39758 13.9831 2.11789 11.9146 3.34259 10.4558C4.19145 9.46114 5.23692 8.76814 6.35798 8.4232L7.46949 8.0812L6.4566 7.50982C5.38499 6.90533 4.64844 5.7537 4.64844 4.44531C4.64844 2.53141 6.20837 0.945312 8.14844 0.945312C10.0623 0.945312 11.6484 2.50524 11.6484 4.44531C11.6484 5.7537 10.9119 6.90533 9.84028 7.50982L8.82738 8.0812L9.93889 8.4232C11.0572 8.7673 12.075 9.4597 12.9291 10.4316ZM1.77454 15.8183L1.75185 16.1587L2.06054 16.304C3.15422 16.8186 5.60627 17.7578 8.21094 17.7578C8.76998 17.7578 9.35547 17.6928 9.90777 17.6314L9.9224 17.6298L10.7297 17.5401L10.286 16.8597C9.86994 16.2217 9.64844 15.5041 9.64844 14.6953C9.64844 13.0546 10.622 11.6301 12.0211 10.9586L12.6904 10.6373L12.141 10.1378C11.0288 9.12674 9.66202 8.53906 8.17969 8.53906C6.45628 8.53906 4.85325 9.3335 3.6744 10.7144L3.67435 10.7144L3.669 10.7209C2.56096 12.0639 1.90537 13.8559 1.77454 15.8183ZM11.2422 4.44531C11.2422 2.73167 9.86208 1.35156 8.14844 1.35156C6.43479 1.35156 5.05469 2.73167 5.05469 4.44531C5.05469 6.15895 6.43479 7.53906 8.14844 7.53906C9.86208 7.53906 11.2422 6.15896 11.2422 4.44531ZM10.0234 14.7266C10.0234 16.784 11.6848 18.4453 13.7422 18.4453C15.7996 18.4453 17.4609 16.784 17.4609 14.7266C17.4609 12.6692 15.7996 11.0078 13.7422 11.0078C11.6848 11.0078 10.0234 12.6692 10.0234 14.7266Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M15.1553 13.6149L15.1553 13.6149L15.1589 13.6113C15.2071 13.5631 15.2566 13.5499 15.2903 13.5506C15.3202 13.5513 15.3524 13.5623 15.3837 13.6014L15.401 13.623L15.4205 13.6426C15.5062 13.7282 15.5065 13.8486 15.4215 13.9345L13.3607 15.964L13.3607 15.964L13.358 15.9667C13.348 15.9767 13.2998 16.0078 13.2116 16.0078H13.2114H13.2112H13.211H13.2109H13.2107H13.2105H13.2103H13.2101H13.21H13.2098H13.2096H13.2094H13.2093H13.2091H13.2089H13.2087H13.2086H13.2084H13.2082H13.2081H13.2079H13.2077H13.2076H13.2074H13.2072H13.2071H13.2069H13.2067H13.2066H13.2064H13.2062H13.2061H13.2059H13.2058H13.2056H13.2054H13.2053H13.2051H13.205H13.2048H13.2047H13.2045H13.2044H13.2042H13.2041H13.2039H13.2037H13.2036H13.2034H13.2033H13.2031H13.203H13.2029H13.2027H13.2026H13.2024H13.2023H13.2021H13.202H13.2018H13.2017H13.2016H13.2014H13.2013H13.2011H13.201H13.2009H13.2007H13.2006H13.2004H13.2003H13.2002H13.2H13.1999H13.1998H13.1996H13.1995H13.1994H13.1992H13.1991H13.199H13.1988H13.1987H13.1986H13.1985H13.1983H13.1982H13.1981H13.198H13.1978H13.1977H13.1976H13.1975H13.1973H13.1972H13.1971H13.197H13.1969H13.1967H13.1966H13.1965H13.1964H13.1963H13.1962H13.196H13.1959H13.1958H13.1957H13.1956H13.1955H13.1954H13.1952H13.1951H13.195H13.1949H13.1948H13.1947H13.1946H13.1945H13.1944H13.1943H13.1941H13.194H13.1939H13.1938H13.1937H13.1936H13.1935H13.1934H13.1933H13.1932H13.1931H13.193H13.1929H13.1928H13.1927H13.1926H13.1925H13.1924H13.1923H13.1922H13.1921H13.192H13.1919H13.1918H13.1918H13.1917H13.1916H13.1915H13.1914H13.1913H13.1912H13.1911H13.191H13.1909H13.1908H13.1908H13.1907H13.1906H13.1905H13.1904H13.1903H13.1902H13.1902H13.1901H13.19H13.1899H13.1898H13.1897H13.1897H13.1896H13.1895H13.1894H13.1893H13.1892H13.1892H13.1891H13.189H13.1889H13.1889H13.1888H13.1887H13.1886H13.1886H13.1885H13.1884H13.1883H13.1883H13.1882H13.1881H13.188H13.188H13.1879H13.1878H13.1878H13.1877H13.1876H13.1875H13.1875H13.1874H13.1873H13.1873H13.1872H13.1871H13.1871H13.187H13.1869H13.1869H13.1868H13.1868H13.1867H13.1866H13.1866H13.1865H13.1864H13.1864H13.1863H13.1863H13.1862H13.1861H13.1861H13.186H13.186H13.1859H13.1858H13.1858H13.1857H13.1857H13.1856H13.1856H13.1855H13.1854H13.1854H13.1853H13.1853H13.1852H13.1852H13.1851H13.1851H13.185H13.185H13.1849H13.1849H13.1848H13.1848H13.1847H13.1847H13.1846H13.1846H13.1845H13.1845H13.1844H13.1844H13.1843H13.1843H13.1842H13.1842H13.1842H13.1841H13.1841H13.184H13.184H13.1839H13.1839H13.1838H13.1838H13.1838H13.1837H13.1837H13.1836H13.1836H13.1836H13.1835H13.1835H13.1834H13.1834H13.1834H13.1833H13.1833H13.1832H13.1832H13.1832H13.1831H13.1831H13.1831H13.183H13.183H13.183H13.1829H13.1829H13.1829H13.1828H13.1828H13.1827H13.1827H13.1827H13.1827H13.1826H13.1826H13.1826H13.1825H13.1825H13.1825H13.1824H13.1824H13.1824H13.1823H13.1823H13.1823H13.1823H13.1822H13.1822H13.1822H13.1821H13.1821H13.1821H13.1821H13.182H13.182H13.182H13.182H13.1819H13.1819H13.1819H13.1819H13.1818H13.1818H13.1818H13.1818H13.1817H13.1817H13.1817H13.1817H13.1817H13.1816H13.1816H13.1816H13.1816H13.1815H13.1815H13.1815H13.1815H13.1815H13.1814H13.1814H13.1814H13.1814H13.1814H13.1813H13.1813H13.1813H13.1813H13.1813H13.1813H13.1812H13.1812H13.1812H13.1812H13.1812H13.1812H13.1811H13.1811H13.1811H13.1811H13.1811H13.1811H13.181H13.181H13.181H13.181H13.181H13.181H13.181H13.1809H13.1809H13.1809H13.1809H13.1809H13.1809H13.1809H13.1809H13.1808H13.1808H13.1808H13.1808H13.1808H13.1808H13.1808H13.1808H13.1808H13.1808H13.1807H13.1807H13.1807H13.1807H13.1807H13.1807H13.1807H13.1807H13.1807H13.1807H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1806H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1805H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1804H13.1803H13.1803H13.1803H13.1803H13.1803H13.1803C13.1688 16.0078 13.1455 16.0045 13.1138 15.9901C13.0849 15.977 13.0587 15.9588 13.0392 15.9406L12.3296 15.1693L12.3225 15.1616L12.3151 15.1542C12.2827 15.1218 12.2634 15.0746 12.2658 15.0173C12.2684 14.9577 12.2938 14.9092 12.325 14.8815L12.336 14.8717L12.3464 14.8613C12.3789 14.8289 12.4261 14.8096 12.4833 14.812C12.5429 14.8146 12.5914 14.84 12.6191 14.8712L12.6289 14.8822L12.6393 14.8926L12.8893 15.1426L13.2393 15.4926L13.5928 15.1461L15.1553 13.6149Z'
              stroke={color}
              strokeWidth='1'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "template":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 21 20'
            fill='none'
            {...rest}
          >
            <path
              d='M12.2835 1.66699H5.61686C5.17483 1.66699 4.75091 1.84259 4.43835 2.15515C4.12579 2.46771 3.9502 2.89163 3.9502 3.33366V16.667C3.9502 17.109 4.12579 17.5329 4.43835 17.8455C4.75091 18.1581 5.17483 18.3337 5.61686 18.3337H15.6169C16.0589 18.3337 16.4828 18.1581 16.7954 17.8455C17.1079 17.5329 17.2835 17.109 17.2835 16.667V6.66699L12.2835 1.66699Z'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.9508 14.167H7.28418'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.9508 10.833H7.28418'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.95085 7.5H8.11751H7.28418'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12.2842 1.66699V6.66699H17.2842'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "fleet":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width={size}
            height={size}
            viewBox='0 0 21 20'
            fill='none'
          >
            <path
              d='M5.61719 1.66699L3.11719 5.00033V16.667C3.11719 17.109 3.29278 17.5329 3.60534 17.8455C3.9179 18.1581 4.34183 18.3337 4.78385 18.3337H16.4505C16.8925 18.3337 17.3165 18.1581 17.629 17.8455C17.9416 17.5329 18.1172 17.109 18.1172 16.667V5.00033L15.6172 1.66699H5.61719Z'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.9499 8.33301C13.9499 9.21706 13.5987 10.0649 12.9736 10.69C12.3484 11.3152 11.5006 11.6663 10.6165 11.6663C9.73248 11.6663 8.88463 11.3152 8.25951 10.69C7.63439 10.0649 7.2832 9.21706 7.2832 8.33301'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M3.11719 5H18.1172'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "workforce":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_1168_19195)'>
              <path
                d='M19.7852 18.3828V16.7161C19.7846 15.9776 19.5388 15.2601 19.0863 14.6764C18.6338 14.0927 18.0003 13.6758 17.2852 13.4911'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M14.7826 18.3828V16.7161C14.7826 15.8321 14.4314 14.9842 13.8062 14.3591C13.1811 13.734 12.3333 13.3828 11.4492 13.3828H4.78255C3.8985 13.3828 3.05065 13.734 2.42553 14.3591C1.80041 14.9842 1.44922 15.8321 1.44922 16.7161V18.3828'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M13.9492 3.49115C14.6662 3.67473 15.3018 4.09173 15.7556 4.67641C16.2094 5.26108 16.4558 5.98017 16.4558 6.72032C16.4558 7.46046 16.2094 8.17955 15.7556 8.76422C15.3018 9.3489 14.6662 9.7659 13.9492 9.94948'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M8.11849 10.0495C9.95944 10.0495 11.4518 8.5571 11.4518 6.71615C11.4518 4.8752 9.95944 3.38281 8.11849 3.38281C6.27754 3.38281 4.78516 4.8752 4.78516 6.71615C4.78516 8.5571 6.27754 10.0495 8.11849 10.0495Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_1168_19195'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.882812)'
                />
              </clipPath>
            </defs>
          </svg>
        );

      case "customer":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 25 25'
            fill='none'
            // stroke={color}
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_166_2102)'>
              <path
                d='M17.9377 11.441L17.9378 11.441C17.9152 11.3168 17.8262 11.2578 17.7422 11.2578H13.5234H13.3316L13.189 11.1295C12.9335 10.8996 12.7015 10.7146 12.4407 10.5067C12.4004 10.4745 12.3594 10.4419 12.3176 10.4084C11.7344 10.0019 11.1633 9.71955 10.5736 9.55107L9.3885 9.21248L10.4745 8.62973C11.595 8.02852 12.3359 6.85316 12.3359 5.47656C12.3359 3.5027 10.716 1.88281 8.74219 1.88281C6.76833 1.88281 5.14844 3.5027 5.14844 5.47656C5.14844 6.81839 5.91787 8.02911 7.0144 8.6322L7.99608 9.17213L6.93861 9.54224C5.76798 9.95196 4.68764 10.6528 3.81065 11.6754C2.55361 13.1672 1.80424 15.2982 1.77345 17.604C1.77435 17.6983 1.82761 17.781 1.89034 17.82C2.72457 18.2507 5.65725 19.5703 8.74219 19.5703C9.02797 19.5703 9.28154 19.5698 9.53072 19.5421L9.54516 19.5405L9.55966 19.5398C10.1212 19.5102 10.7207 19.4209 11.3316 19.2988C11.6193 19.2412 11.9378 19.1545 12.2565 19.0388C12.2573 19.0385 12.258 19.0382 12.2588 19.0379L13.0041 18.7584L13.2817 18.6543L13.5062 18.8479C14.2911 19.5245 15.1025 19.7593 15.3796 19.8245C15.4144 19.8284 15.4452 19.8345 15.4706 19.8407L15.5087 19.8322C15.744 19.7799 16.5915 19.5566 17.4424 18.8205C18.0223 18.2978 18.5005 17.6721 18.778 16.9784L18.7806 16.9718L18.7834 16.9653C19.1617 16.0924 19.3984 15.0352 19.3984 13.8516V13.7815L19.4177 13.7142C19.422 13.6991 19.4224 13.6909 19.4224 13.6886L19.4224 13.6871L17.9377 11.441ZM17.9377 11.441L17.9385 11.4451C18.0204 11.8748 18.2537 12.3029 18.5147 12.6691C18.7768 13.0368 19.0939 13.3799 19.3962 13.6505L17.9377 11.441ZM11.2525 18.9088C11.573 18.867 11.8723 18.7502 12.1919 18.5919L12.4178 18.5072L13.0541 18.2686L12.6369 17.7321C12.4568 17.5006 12.3207 17.2344 12.168 16.8988C11.7948 16.0358 11.5854 14.981 11.5547 13.7841C11.5553 13.7443 11.5625 13.7052 11.5736 13.6756C11.5805 13.6571 11.5864 13.6487 11.5883 13.6462L11.6002 13.6367L11.6137 13.6242C12.062 13.2079 12.665 12.55 12.9269 11.8765L13.0452 11.5725L12.8145 11.3418C12.6231 11.1504 12.4036 10.9869 12.1952 10.8317C12.1648 10.809 12.1346 10.7865 12.1047 10.7641L12.0893 10.7525L12.0731 10.7422C11.3512 10.2828 10.6012 9.93639 9.79661 9.79646C7.64374 9.42068 5.56229 10.2129 4.10993 11.9355L4.10991 11.9355L4.10731 11.9386C2.96573 13.3153 2.31123 15.1403 2.18072 17.1631L2.15884 17.5023L2.46618 17.6474C3.61886 18.1918 6.10352 19.1641 8.74219 19.1641H8.75483C8.99177 19.1641 9.26171 19.1641 9.53676 19.1311C10.121 19.0974 10.7004 19.0009 11.249 18.9094L11.2525 18.9088ZM13.6288 11.6953L13.5663 11.7578H13.4037L13.278 12.0721C13.0029 12.7597 12.4655 13.3899 12.0761 13.7793L11.9227 13.9327L11.93 14.1495C11.9629 15.1384 12.1605 16.0463 12.5029 16.8021C12.7857 17.4707 13.2393 18.0607 13.7585 18.5107L13.7584 18.5107L13.7658 18.5169C14.3942 19.0405 15.0208 19.284 15.3341 19.3884L15.4922 19.4411L15.6503 19.3884C15.9636 19.284 16.5902 19.0405 17.2185 18.5169L17.2186 18.517L17.2259 18.5107C17.7461 18.0598 18.2004 17.4684 18.4831 16.7982C18.8219 16.0182 19.0234 15.1388 19.0234 14.1328V13.9365L18.8898 13.7926C18.4786 13.3497 17.9198 12.7266 17.6464 12.0158L17.5231 11.6953H17.1797H13.8359H13.6288ZM13.4199 11.8886C13.4185 11.89 13.4188 11.8897 13.4203 11.8882L13.4199 11.8886L13.4199 11.8886ZM11.9297 5.53906C11.9297 3.75914 10.4833 2.35156 8.74219 2.35156C7.00109 2.35156 5.55469 3.75914 5.55469 5.53906C5.55469 7.31521 6.96605 8.72656 8.74219 8.72656C10.5221 8.72656 11.9297 7.28016 11.9297 5.53906Z'
                stroke={color}
                strokeWidth='1'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_166_2102'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.882812)'
                />
              </clipPath>
            </defs>
          </svg>
        );

      case "logout":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 25 25'
            fill='none'
            // stroke={color}
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M13.9492 15.0495L18.1159 10.8828L13.9492 6.71616'
              stroke={color}
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M18.1172 10.8828H8.11719'
              stroke={color}
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M8.11719 18.3828H4.78385C4.34183 18.3828 3.9179 18.2072 3.60534 17.8947C3.29278 17.5821 3.11719 17.1582 3.11719 16.7161V5.04948C3.11719 4.60745 3.29278 4.18353 3.60534 3.87097C3.9179 3.55841 4.34183 3.38281 4.78385 3.38281H8.11719'
              stroke={color}
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "edit-icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 25 25'
            fill='none'
            // stroke={color}
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M11.8125 4.5H4.8125C4.28207 4.5 3.77336 4.71071 3.39829 5.08579C3.02321 5.46086 2.8125 5.96957 2.8125 6.5V20.5C2.8125 21.0304 3.02321 21.5391 3.39829 21.9142C3.77336 22.2893 4.28207 22.5 4.8125 22.5H18.8125C19.3429 22.5 19.8516 22.2893 20.2267 21.9142C20.6018 21.5391 20.8125 21.0304 20.8125 20.5V13.5'
              stroke={color}
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M19.3125 3.00023C19.7103 2.6024 20.2499 2.37891 20.8125 2.37891C21.3751 2.37891 21.9147 2.6024 22.3125 3.00023C22.7103 3.39805 22.9338 3.93762 22.9338 4.50023C22.9338 5.06284 22.7103 5.6024 22.3125 6.00023L12.8125 15.5002L8.8125 16.5002L9.8125 12.5002L19.3125 3.00023Z'
              stroke={color}
              strokeWidth='2'
              strokeMiterlimit='10'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );

      case "cloud-icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 25 25'
            fill='none'
            // stroke={color}
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g opacity='0.6' clipPath='url(#clip0_811_25718)'>
              <path
                d='M16.5 16.5L12.5 12.5L8.5 16.5'
                stroke={color}
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M12.5 12.5V21.5'
                stroke={color}
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M20.8895 18.8914C21.8648 18.3597 22.6353 17.5183 23.0793 16.5001C23.5234 15.4818 23.6157 14.3447 23.3417 13.2681C23.0677 12.1916 22.443 11.237 21.5661 10.5549C20.6893 9.87283 19.6103 9.50218 18.4995 9.50145H17.2395C16.9368 8.33069 16.3726 7.24378 15.5894 6.32244C14.8062 5.4011 13.8243 4.6693 12.7176 4.18206C11.6108 3.69481 10.408 3.46481 9.19959 3.50933C7.99116 3.55385 6.80854 3.87175 5.74065 4.43911C4.67276 5.00648 3.74738 5.80855 3.03409 6.78503C2.3208 7.76151 1.83816 8.88699 1.62245 10.0768C1.40674 11.2667 1.46358 12.49 1.78869 13.6547C2.11379 14.8194 2.69871 15.8953 3.49947 16.8014'
                stroke={color}
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M16.5 16.5L12.5 12.5L8.5 16.5'
                stroke={color}
                strokeWidth='2'
                strokeMiterlimit='10'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_811_25718'>
                <rect
                  width='24'
                  height='24'
                  fill='white'
                  transform='translate(0.5 0.5)'
                />
              </clipPath>
            </defs>
          </svg>
        );

      case "setting-icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_2854_41100)'>
              <path
                d='M10.6172 13.3828C11.9979 13.3828 13.1172 12.2635 13.1172 10.8828C13.1172 9.5021 11.9979 8.38281 10.6172 8.38281C9.23648 8.38281 8.11719 9.5021 8.11719 10.8828C8.11719 12.2635 9.23648 13.3828 10.6172 13.3828Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M16.784 13.3835C16.6731 13.6348 16.64 13.9136 16.689 14.184C16.738 14.4543 16.8669 14.7037 17.059 14.9001L17.109 14.9501C17.264 15.1049 17.3869 15.2887 17.4708 15.4911C17.5547 15.6934 17.5978 15.9103 17.5978 16.1293C17.5978 16.3483 17.5547 16.5652 17.4708 16.7675C17.3869 16.9699 17.264 17.1537 17.109 17.3085C16.9542 17.4634 16.7704 17.5864 16.5681 17.6702C16.3658 17.7541 16.1489 17.7973 15.9298 17.7973C15.7108 17.7973 15.4939 17.7541 15.2916 17.6702C15.0893 17.5864 14.9055 17.4634 14.7507 17.3085L14.7007 17.2585C14.5043 17.0663 14.2548 16.9375 13.9845 16.8885C13.7142 16.8394 13.4354 16.8725 13.184 16.9835C12.9375 17.0891 12.7273 17.2645 12.5793 17.4881C12.4312 17.7116 12.3518 17.9736 12.3507 18.2418V18.3835C12.3507 18.8255 12.1751 19.2494 11.8625 19.562C11.55 19.8745 11.126 20.0501 10.684 20.0501C10.242 20.0501 9.81807 19.8745 9.50551 19.562C9.19294 19.2494 9.01735 18.8255 9.01735 18.3835V18.3085C9.0109 18.0326 8.92161 17.7651 8.76111 17.5407C8.6006 17.3163 8.3763 17.1454 8.11735 17.0501C7.866 16.9392 7.58719 16.9061 7.31686 16.9551C7.04653 17.0041 6.79708 17.133 6.60068 17.3251L6.55068 17.3751C6.39589 17.5301 6.21208 17.653 6.00975 17.7369C5.80742 17.8208 5.59054 17.8639 5.37152 17.8639C5.15249 17.8639 4.93561 17.8208 4.73328 17.7369C4.53095 17.653 4.34714 17.5301 4.19235 17.3751C4.03739 17.2203 3.91446 17.0365 3.83058 16.8342C3.74671 16.6319 3.70354 16.415 3.70354 16.196C3.70354 15.9769 3.74671 15.7601 3.83058 15.5577C3.91446 15.3554 4.03739 15.1716 4.19235 15.0168L4.24235 14.9668C4.43446 14.7704 4.56334 14.5209 4.61235 14.2506C4.66137 13.9803 4.62828 13.7015 4.51735 13.4501C4.41171 13.2037 4.23631 12.9934 4.01274 12.8454C3.78916 12.6973 3.52717 12.6179 3.25902 12.6168H3.11735C2.67532 12.6168 2.2514 12.4412 1.93884 12.1286C1.62628 11.8161 1.45068 11.3922 1.45068 10.9501C1.45068 10.5081 1.62628 10.0842 1.93884 9.77162C2.2514 9.45906 2.67532 9.28346 3.11735 9.28346H3.19235C3.46818 9.27701 3.73569 9.18773 3.9601 9.02722C4.18451 8.86672 4.35545 8.64241 4.45068 8.38346C4.56161 8.13212 4.5947 7.8533 4.54569 7.58297C4.49667 7.31264 4.3678 7.0632 4.17568 6.8668L4.12568 6.8168C3.97072 6.66201 3.84779 6.47819 3.76392 6.27586C3.68004 6.07353 3.63687 5.85666 3.63687 5.63763C3.63687 5.4186 3.68004 5.20173 3.76392 4.9994C3.84779 4.79707 3.97072 4.61325 4.12568 4.45846C4.28047 4.3035 4.46429 4.18057 4.66662 4.0967C4.86895 4.01282 5.08582 3.96965 5.30485 3.96965C5.52388 3.96965 5.74075 4.01282 5.94308 4.0967C6.14541 4.18057 6.32923 4.3035 6.48402 4.45846L6.53402 4.50846C6.73042 4.70058 6.97986 4.82945 7.25019 4.87847C7.52052 4.92748 7.79934 4.89439 8.05068 4.78346H8.11735C8.36382 4.67783 8.57403 4.50243 8.72209 4.27885C8.87016 4.05528 8.94961 3.79329 8.95068 3.52513V3.38346C8.95068 2.94144 9.12628 2.51751 9.43884 2.20495C9.7514 1.89239 10.1753 1.7168 10.6173 1.7168C11.0594 1.7168 11.4833 1.89239 11.7959 2.20495C12.1084 2.51751 12.284 2.94144 12.284 3.38346V3.45846C12.2851 3.72662 12.3645 3.98861 12.5126 4.21218C12.6607 4.43576 12.8709 4.61116 13.1173 4.7168C13.3687 4.82773 13.6475 4.86082 13.9178 4.8118C14.1882 4.76278 14.4376 4.63391 14.634 4.4418L14.684 4.3918C14.8388 4.23684 15.0226 4.1139 15.2249 4.03003C15.4273 3.94616 15.6442 3.90299 15.8632 3.90299C16.0822 3.90299 16.2991 3.94616 16.5014 4.03003C16.7037 4.1139 16.8876 4.23684 17.0423 4.3918C17.1973 4.54659 17.3202 4.7304 17.4041 4.93273C17.488 5.13506 17.5312 5.35194 17.5312 5.57096C17.5312 5.78999 17.488 6.00687 17.4041 6.2092C17.3202 6.41153 17.1973 6.59534 17.0423 6.75013L16.9923 6.80013C16.8002 6.99653 16.6714 7.24598 16.6223 7.51631C16.5733 7.78663 16.6064 8.06545 16.7173 8.3168V8.38346C16.823 8.62994 16.9984 8.84014 17.222 8.98821C17.4455 9.13627 17.7075 9.21573 17.9757 9.2168H18.1173C18.5594 9.2168 18.9833 9.39239 19.2959 9.70495C19.6084 10.0175 19.784 10.4414 19.784 10.8835C19.784 11.3255 19.6084 11.7494 19.2959 12.062C18.9833 12.3745 18.5594 12.5501 18.1173 12.5501H18.0423C17.7742 12.5512 17.5122 12.6307 17.2886 12.7787C17.0651 12.9268 16.8897 13.137 16.784 13.3835V13.3835Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_2854_41100'>
                <rect
                  width='20'
                  height='20'
                  fill={color}
                  transform='translate(0.617188 0.882812)'
                />
              </clipPath>
            </defs>
          </svg>
        );

      case "roaster-icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill={"transparent"}
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <g clipPath='url(#clip0_2854_40987)'>
              <path
                d='M16.4505 4.2168H4.78385C3.86338 4.2168 3.11719 4.96299 3.11719 5.88346V17.5501C3.11719 18.4706 3.86338 19.2168 4.78385 19.2168H16.4505C17.371 19.2168 18.1172 18.4706 18.1172 17.5501V5.88346C18.1172 4.96299 17.371 4.2168 16.4505 4.2168Z'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M3.11719 9.2168H18.1172'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M13.9507 2.54883V5.88216'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M7.28369 2.54883V5.88216'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_2854_40987'>
                <rect
                  width='20'
                  height='20'
                  fill={color}
                  transform='translate(0.617188 0.882812)'
                />
              </clipPath>
            </defs>
          </svg>
        );

      case "suitcase":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M17.2837 6.71582H3.95036C3.02988 6.71582 2.28369 7.46201 2.28369 8.38249V16.7158C2.28369 17.6363 3.02988 18.3825 3.95036 18.3825H17.2837C18.2042 18.3825 18.9504 17.6363 18.9504 16.7158V8.38249C18.9504 7.46201 18.2042 6.71582 17.2837 6.71582Z'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.9504 18.3828V5.04948C13.9504 4.60745 13.7748 4.18353 13.4622 3.87097C13.1496 3.55841 12.7257 3.38281 12.2837 3.38281H8.95036C8.50833 3.38281 8.08441 3.55841 7.77185 3.87097C7.45929 4.18353 7.28369 4.60745 7.28369 5.04948V18.3828'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "time-icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 21'
            fill='none'
            {...rest}
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clipPath='url(#clip0_3391_69576)'>
              <path
                d='M10.6175 19.2174C15.2199 19.2174 18.9508 15.4865 18.9508 10.8841C18.9508 6.28174 15.2199 2.55078 10.6175 2.55078C6.01514 2.55078 2.28418 6.28174 2.28418 10.8841C2.28418 15.4865 6.01514 19.2174 10.6175 19.2174Z'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M10.6172 5.88281V10.8828L13.9505 12.5495'
                stroke={color}
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_3391_69576'>
                <rect
                  width='20'
                  height='20'
                  fill='white'
                  transform='translate(0.617188 0.882812)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "colon-icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            {...rest}
          >
            <circle cx='12' cy='6' r='1' />
            <circle cx='12' cy='18' r='1' />
          </svg>
        );
      case "vertical-three-dots":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            {...rest}
          >
            <circle cx='12' cy='12' r='1' />
            <circle cx='12' cy='5' r='1' />
            <circle cx='12' cy='19' r='1' />
          </svg>
        );
      case "arrow-back":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='lucide lucide-arrow-left'
            {...rest}
          >
            <path d='M15 18l-6-6 6-6' />
            <path d='M21 12H9' />
          </svg>
        );
      case "Extract-Icon":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 18 18'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M14.25 7.5H3.75L7.95 12.23V15.5L10.05 16.5V12.23L14.25 7.5Z'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <g clipPath='url(#clip0_532_48137)'>
              <path
                d='M6.125 7.5V2.25C6.125 2.05109 6.2106 1.86032 6.36298 1.71967C6.51535 1.57902 6.72201 1.5 6.9375 1.5H10.3906L12.625 3.5625C12.625 3.5625 12.625 6.2552 12.625 7.5'
                stroke={color}
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_532_48137'>
                <rect
                  width='8.25'
                  height='6.75'
                  fill={color}
                  transform='translate(5.25 0.75)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "arrowup-line":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='lucide lucide-upload'
            {...rest}
          >
            <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
            <polyline points='17 8 12 3 7 8' />
            <line x1='12' x2='12' y1='3' y2='15' />
          </svg>
        );
      case "cloud-upload":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 18 14'
            fill='none'
            {...rest}
          >
            <path
              d='M9.73183 5.62422C9.56308 5.45547 9.33809 5.37109 9.11309 5.37109C8.88809 5.37109 8.66308 5.45547 8.49433 5.62422L7.17246 7.00234C6.91933 7.25547 6.94746 7.64922 7.20058 7.90234C7.45371 8.15547 7.84746 8.12734 8.10058 7.87422L8.52246 7.45234V9.61797C8.52246 9.95547 8.80371 10.2648 9.16933 10.2648C9.50683 10.2648 9.81621 9.98359 9.81621 9.61797V7.45234L10.2381 7.87422C10.3506 8.01484 10.5193 8.07109 10.6881 8.07109C10.8568 8.07109 10.9975 8.01484 11.1381 7.90234C11.3912 7.64922 11.3912 7.25547 11.1662 7.00234L9.73183 5.62422Z'
              fill={color}
            />
            <path
              d='M16.1152 4.63828C15.3559 3.82266 14.3152 3.28828 13.2184 3.09141C12.5996 2.13516 11.6996 1.43203 10.659 1.06641C10.1809 0.897656 9.61836 0.785156 9.02773 0.785156C6.38398 0.785156 4.19023 2.81016 4.02148 5.36953C2.02461 5.62266 0.505859 7.28203 0.505859 9.2789C0.505859 11.4445 2.27773 13.1883 4.47148 13.1883H12.2902C15.159 13.1883 17.5215 10.9102 17.5215 8.09766C17.5215 6.83203 17.0152 5.59453 16.1152 4.63828ZM12.2902 11.9508H4.49961C2.95273 11.9508 1.77148 10.7695 1.77148 9.30703C1.77148 7.81641 2.98086 6.66328 4.49961 6.66328H4.64023C4.97773 6.66328 5.28711 6.38203 5.28711 6.01641V5.73516C5.28711 3.71016 6.97461 2.07891 9.02773 2.07891C9.47773 2.07891 9.87148 2.13516 10.2371 2.27578C11.109 2.55703 11.8402 3.17578 12.2902 3.99141C12.4027 4.16016 12.5715 4.30078 12.7684 4.30078C13.6965 4.38516 14.5965 4.83516 15.2152 5.51016C15.8902 6.24141 16.2559 7.16953 16.2559 8.12578C16.2559 10.2352 14.4559 11.9508 12.2902 11.9508Z'
              fill={color}
            />
          </svg>
        );
      case "refresh-sync":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='lucide lucide-refresh-ccw'
          >
            <path d='M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
            <path d='M3 3v5h5' />
            <path d='M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16' />
            <path d='M16 16h5v5' />
          </svg>
        );
      case "bar-chart":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill='none'
          >
            <path
              d='M4 13.334V9.33398'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <path
              d='M12 13.3327V6.66602'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
            <path
              d='M8 13.3327V2.66602'
              stroke='currentColor'
              strokeWidth='2'
              strokeLinecap='round'
            />
          </svg>
        );

      case "folder":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 38 39'
            fill='none'
            {...rest}
          >
            <g clipPath='url(#clip0_6370_40802)'>
              <path
                d='M13.6003 9.67239H4.08212C3.58582 9.67239 3.13205 9.39199 2.91013 8.94801L1.96191 7.05172L2.91013 5.15544C3.13205 4.71146 3.58575 4.43106 4.08212 4.43106H13.6004C14.0967 4.43106 14.5505 4.71146 14.7724 5.15544L15.7205 7.05172L14.7723 8.94801C14.5504 9.39199 14.0967 9.67239 13.6003 9.67239Z'
                fill='#FFC36E'
              />
              <path
                d='M13.6003 9.67239H4.08212C3.58582 9.67239 3.13205 9.39199 2.91013 8.94801L1.96191 7.05172L2.91013 5.15544C3.13205 4.71146 3.58575 4.43106 4.08212 4.43106H13.6004C14.0967 4.43106 14.5505 4.71146 14.7724 5.15544L15.7205 7.05172L14.7723 8.94801C14.5504 9.39199 14.0967 9.67239 13.6003 9.67239Z'
                fill='#FFC36E'
              />
              <path
                d='M36.0308 5.74139H1.96184C1.60003 5.74139 1.30664 6.03478 1.30664 6.3966V9.67246H36.686V6.39652C36.686 6.03471 36.3926 5.74139 36.0308 5.74139Z'
                fill='#EFF2FA'
              />
              <path
                d='M36.686 8.36206H1.30664V9.67239H36.686V8.36206Z'
                fill='#E1E6F2'
              />
              <path
                d='M36.6858 7.05173H16.1252C15.8771 7.05173 15.6502 7.19193 15.5392 7.41384L14.7721 8.94802C14.5502 9.39199 14.0963 9.67239 13.6001 9.67239H4.08184C3.58554 9.67239 3.13176 9.39199 2.90985 8.94802L2.14265 7.41384C2.03169 7.19193 1.8048 7.05173 1.55669 7.05173H1.30643C0.582719 7.05173 -0.00390625 7.63835 -0.00390625 8.36206V33.2586C-0.00390625 33.9823 0.582719 34.5689 1.30643 34.5689H36.6858C37.4095 34.5689 37.9961 33.9823 37.9961 33.2586V8.36206C37.9961 7.63835 37.4095 7.05173 36.6858 7.05173Z'
                fill='#FFD782'
              />
              <path
                d='M36.0308 33.2586H1.96184C1.60003 33.2586 1.30664 32.9652 1.30664 32.6034C1.30664 32.2416 1.60003 31.9482 1.96184 31.9482H36.0308C36.3926 31.9482 36.686 32.2416 36.686 32.6034C36.686 32.9653 36.3926 33.2586 36.0308 33.2586Z'
                fill='#FFC36E'
              />
              <path
                d='M24.2372 16.8794H34.0648C34.4267 16.8794 34.72 16.586 34.72 16.2242V10.9827C34.72 10.6209 34.4267 10.3275 34.0648 10.3275H24.2372C23.8754 10.3275 23.582 10.6209 23.582 10.9827V16.2242C23.582 16.586 23.8754 16.8794 24.2372 16.8794Z'
                fill='#EFF2FA'
              />
              <path
                d='M32.7546 12.9483H25.5478C25.186 12.9483 24.8926 12.6549 24.8926 12.2931C24.8926 11.9312 25.186 11.6378 25.5478 11.6378H32.7546C33.1165 11.6378 33.4098 11.9312 33.4098 12.2931C33.4098 12.6549 33.1165 12.9483 32.7546 12.9483Z'
                fill='#C7CFE2'
              />
              <path
                d='M32.7546 15.5689H25.5478C25.186 15.5689 24.8926 15.2755 24.8926 14.9137C24.8926 14.5519 25.186 14.2585 25.5478 14.2585H32.7546C33.1165 14.2585 33.4098 14.5519 33.4098 14.9137C33.4098 15.2756 33.1165 15.5689 32.7546 15.5689Z'
                fill='#D7DEED'
              />
            </g>
            <defs>
              <clipPath id='clip0_6370_40802'>
                <rect
                  width='38'
                  height='38'
                  fill='white'
                  transform='translate(-0.00390625 0.5)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "trending-up":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              d='M18.9508 5.83331L11.8675 12.9166L7.70085 8.74998L2.28418 14.1666'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.9502 5.83331H18.9502V10.8333'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "lollipop":
        return (
          <svg
            ref={ref}
            width={20}
            height={30}
            viewBox='0 0 20 45'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <g clipPath='url(#clip0_102_14116)'>
              <path d='M10.6172 21.6172L10.6172 44.6172' stroke={color} />
              <circle cx='10.6172' cy='22.6172' r='10' fill='white' />
              <circle cx='10.6172' cy='22.6172' r='5' fill={color} />
            </g>
            <defs>
              <clipPath id='clip0_102_14116'>
                <rect
                  width='20'
                  height='44'
                  fill='white'
                  transform='translate(0.617188 0.617188)'
                />
              </clipPath>
            </defs>
          </svg>
        );
      case "document-parser":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M3.9502 18.3334H15.6169C16.0589 18.3334 16.4828 18.1578 16.7954 17.8452C17.1079 17.5326 17.2835 17.1087 17.2835 16.6667V6.25002L12.7002 1.66669H5.61686C5.17483 1.66669 4.75091 1.84228 4.43835 2.15484C4.12579 2.4674 3.9502 2.89133 3.9502 3.33335V6.66669'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M12.2842 1.66669V6.66669H17.2842'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M2.28418 12.5H10.6175'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M4.78418 10L2.28418 12.5L4.78418 15'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "calendar":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 21 20'
            fill='none'
          >
            <path
              d='M16.4505 3.33334H4.78385C3.86338 3.33334 3.11719 4.07954 3.11719 5.00001V16.6667C3.11719 17.5872 3.86338 18.3333 4.78385 18.3333H16.4505C17.371 18.3333 18.1172 17.5872 18.1172 16.6667V5.00001C18.1172 4.07954 17.371 3.33334 16.4505 3.33334Z'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M3.11719 8.33334H18.1172'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M13.9506 1.66666V4.99999'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M7.28381 1.66666V4.99999'
              stroke={color}
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "cloud-upload-2":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 63 64'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M42 42.5L31.5 32L21 42.5'
              stroke={color}
              strokeWidth='4'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M31.5 32V55.625'
              stroke={color}
              strokeWidth='4'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M53.5237 48.7736C56.084 47.3779 58.1065 45.1692 59.2721 42.4963C60.4377 39.8234 60.68 36.8384 59.9607 34.0125C59.2415 31.1865 57.6016 28.6806 55.3 26.8902C52.9983 25.0998 50.166 24.1268 47.25 24.1249H43.9425C43.1479 21.0517 41.667 18.1985 39.6111 15.78C37.5551 13.3615 34.9777 11.4405 32.0725 10.1615C29.1673 8.88248 26.0099 8.27871 22.8378 8.39559C19.6656 8.51246 16.5613 9.34693 13.758 10.8363C10.9548 12.3256 8.52572 14.431 6.65334 16.9943C4.78095 19.5576 3.51402 22.5119 2.94778 25.6353C2.38154 28.7587 2.53073 31.9698 3.38414 35.0272C4.23755 38.0846 5.77297 40.9088 7.87496 43.2874'
              stroke={color}
              strokeWidth='4'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M42 42.5L31.5 32L21 42.5'
              stroke={color}
              strokeWidth='4'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
      case "bell":
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
            className='lucide lucide-bell'
          >
            <path d='M10.268 21a2 2 0 0 0 3.464 0' />
            <path d='M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326' />
          </svg>
        );

      case "map-pin":
        return (
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='36'
            height='36'
            viewBox='0 0 24 24'
            fill={color}
            stroke={color}
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path d='M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0' />
            <circle cx='12' cy='10' r='3' fill='white' />
          </svg>
        );

      default:
        return (
          <svg
            ref={ref}
            width={size}
            height={size}
            viewBox='0 0 20 21'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...rest}
          >
            <path
              id='Vector'
              d='M0.679688 9.88281C0.679688 4.90358 4.67993 0.851562 9.61719 0.851562C14.5544 0.851562 18.5547 4.90358 18.5547 9.88281C18.5547 14.862 14.5544 18.9141 9.61719 18.9141C4.67993 18.9141 0.679688 14.862 0.679688 9.88281ZM1.05469 9.88281C1.05469 14.6239 4.89979 18.5078 9.61719 18.5078C14.3346 18.5078 18.1797 14.6239 18.1797 9.88281C18.1797 5.14169 14.3346 1.25781 9.61719 1.25781C4.89979 1.25781 1.05469 5.14169 1.05469 9.88281Z'
              stroke={color}
              strokeWidth='1'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector2'
              d='M12.5234 13.6641H13.0234V13.1641V5.88281C13.0234 5.78395 13.1121 5.69531 13.2109 5.69531C13.2991 5.69531 13.4111 5.77801 13.4297 5.90898V13.4766C13.4297 13.7942 13.1535 14.0703 12.8359 14.0703H9.64844C8.86208 14.0703 8.24219 13.4504 8.24219 12.6641V9.28906C8.24219 9.19021 8.33083 9.10156 8.42969 9.10156C8.52854 9.10156 8.61719 9.1902 8.61719 9.28906V12.6641C8.61719 13.2215 9.0598 13.6641 9.61719 13.6641H12.5234Z'
              stroke={color}
              strokeWidth='1'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              id='Vector3'
              d='M6.71094 6.10156H6.21094V6.60156V13.8828C6.21094 13.9817 6.1223 14.0703 6.02344 14.0703C5.92458 14.0703 5.83594 13.9817 5.83594 13.8828V6.28906C5.83594 5.97145 6.11208 5.69531 6.42969 5.69531H9.58594C10.3723 5.69531 10.9922 6.3152 10.9922 7.10156V10.4766C10.9922 10.5754 10.9035 10.6641 10.8047 10.6641C10.7058 10.6641 10.6172 10.5754 10.6172 10.4766V7.10156C10.6172 6.54417 10.1746 6.10156 9.61719 6.10156H6.71094Z'
              stroke={color}
              strokeWidth='1'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        );
    }
  },
);

Icons.displayName = "Icons";
export default Icons;
